var render = function render(){var _vm=this,_c=_vm._self._c;return _c('as-modal',{attrs:{"title":"About AccountScore"},on:{"close":function($event){return _vm.$emit('close', $event)}}},[_c('p',[_vm._v("AccountScore is a third-party service used to provide more financial information for your application. This service uses bank level security processes to connect safely to your bank account. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }